export interface Category {
  name: string;
  url: string;
  icon: string;
  seq: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    seq: 'cat-shoes-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20white%20leather%20sneakers%20on%20warm%20terracotta%20ceramic%20tile%20surface%2C%20soft%20afternoon%20sunlight%20through%20linen%20curtain%2C%20minimal%20editorial%20product%20photography%2C%20clean%20composition%20with%20organic%20shadows&width=200&height=200&seq=cat-thumb-shoes-v2&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    seq: 'cat-hoodies-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20sage%20green%20hoodie%20folded%20neatly%20on%20light%20oak%20wooden%20surface%2C%20soft%20diffused%20morning%20light%2C%20minimalist%20product%20photography%2C%20scandinavian%20aesthetic%20with%20organic%20fabric%20texture&width=200&height=200&seq=cat-thumb-hoodies-v2&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-t-shirt-line',
    seq: 'cat-tshirts-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20t-shirt%20draped%20on%20warm%20sand%20colored%20linen%2C%20soft%20natural%20window%20light%20from%20top%20right%2C%20minimal%20editorial%20photography%2C%20clean%20relaxed%20composition&width=200&height=200&seq=cat-thumb-tshirt-v2&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-shirt-line',
    seq: 'cat-jackets-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20on%20cream%20textured%20wall%20hook%2C%20soft%20side%20lighting%20creating%20dramatic%20fabric%20shadows%2C%20minimalist%20editorial%20style%2C%20subtle%20military%20aesthetic&width=200&height=200&seq=cat-thumb-jackets-v2&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-pantone-line',
    seq: 'cat-pants-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Well%20fitted%20beige%20chinos%20folded%20on%20warm%20grey%20concrete%20surface%2C%20soft%20overhead%20natural%20light%2C%20minimal%20product%20photography%2C%20clean%20modern%20composition%20with%20gentle%20creases&width=200&height=200&seq=cat-thumb-pants-v2&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-customer-service-2-line',
    seq: 'cat-headwear-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Navy%20blue%20baseball%20cap%20on%20warm%20oatmeal%20textured%20fabric%20surface%2C%20soft%20morning%20light%20from%20left%2C%20minimal%20editorial%20photography%2C%20clean%20casual%20aesthetic%20with%20subtle%20embroidery%20detail&width=200&height=200&seq=cat-thumb-headwear-v2&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    seq: 'cat-sets-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20cream%20linen%20shirt%20and%20shorts%20set%20laid%20flat%20on%20warm%20beige%20backdrop%2C%20soft%20natural%20diffused%20lighting%2C%20minimalist%20editorial%20style%2C%20clean%20summer%20aesthetic%20composition&width=200&height=200&seq=cat-thumb-sets-v2&orientation=squarish',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-user-line',
    seq: 'cat-underwear-08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20grey%20organic%20cotton%20underwear%20on%20warm%20cream%20marble%20surface%2C%20gentle%20studio%20lighting%20from%20above%2C%20minimal%20product%20photography%2C%20clean%20aesthetic%20with%20subtle%20elastic%20texture&width=200&height=200&seq=cat-thumb-underwear-v2&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-shirt-line',
    seq: 'cat-jersey-09',
    imageUrl: 'https://readdy.ai/api/search-image?query=Forest%20green%20knit%20jersey%20fabric%20rolled%20on%20light%20oak%20table%2C%20soft%20afternoon%20light%20highlighting%20texture%2C%20minimal%20editorial%20photography%2C%20warm%20cozy%20aesthetic&width=200&height=200&seq=cat-thumb-jersey-v2&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-bear-smile-line',
    seq: 'cat-accessories-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gold%20toned%20minimal%20bracelet%20and%20round%20sunglasses%20on%20warm%20terracotta%20surface%2C%20soft%20sunset%20light%20casting%20long%20shadows%2C%20minimal%20editorial%20photography%2C%20elegant%20aesthetic&width=200&height=200&seq=cat-thumb-acc-v2&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-briefcase-line',
    seq: 'cat-bags-11',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cognac%20brown%20leather%20crossbody%20bag%20on%20cream%20linen%20surface%2C%20soft%20natural%20side%20lighting%2C%20minimal%20product%20photography%2C%20clean%20editorial%20style%20with%20brass%20hardware%20detail&width=200&height=200&seq=cat-thumb-bags-v2&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-link',
    seq: 'cat-belts-12',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20brown%20braided%20leather%20belt%20coiled%20on%20warm%20beige%20textured%20surface%2C%20soft%20overhead%20lighting%2C%20minimal%20product%20photography%2C%20clean%20editorial%20composition&width=200&height=200&seq=cat-thumb-belts-v2&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-drop-line',
    seq: 'cat-perfumes-13',
    imageUrl: 'https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20with%20minimal%20label%20on%20warm%20grey%20stone%20surface%2C%20soft%20dramatic%20side%20lighting%20with%20long%20shadow%2C%20minimal%20editorial%20product%20photography&width=200&height=200&seq=cat-thumb-perfume-v2&orientation=squarish',
  },
  {
    name: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-more-line',
    seq: 'cat-other-14',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20minimal%20lifestyle%20items%20including%20notebook%20and%20ceramic%20mug%20on%20warm%20oatmeal%20linen%2C%20soft%20morning%20light%2C%20clean%20scandinavian%20editorial%20photography&width=200&height=200&seq=cat-thumb-other-v2&orientation=squarish',
  },
];